<template>
  <sweet-modal title="Issue Sales Invoice" width="900" blocking ref="modal">
    <el-form label-width="190px" :model="form" label-position="left" size="mini" ref="form" status-icon :rules="rules" class="rule-form">
    <el-row :span="24" :gutter="30">
      <el-col :span="16">
          <h4>Receipt Advice</h4>
          <el-form-item  label="CR ID#">
            <el-input v-model="transactionNo" readonly placeholder="CR ID#">
            </el-input>
          </el-form-item>
          <el-form-item prop="templateName" label="Template">
            <el-input v-model="form.templateName">
            </el-input>
          </el-form-item>
          <el-form-item prop="orNumber" label="Sales Invoice Number">
            <el-input v-model="form.orNumber">
            </el-input>
          </el-form-item>
          <el-form-item prop="issueDate" label="Transaction Date">
            <el-date-picker
                style="width: 100%;"
                v-model="form.issueDate"
                :clearable='false'
                format="d MMM yy"
                value-format="MM-dd-yyyy"
                type="date"
                placeholder="Select Date">
            </el-date-picker>
          </el-form-item>
          <h4 style="margin-top: 24px;">Receipt Delivery</h4>
          <el-form-item label-width="0" prop="ifSend">
            <el-radio-group v-model="form.ifSend" size="mini">
              <el-radio label="send">Send email to client</el-radio>
              <el-radio label="dontSend">Don't send email to client</el-radio>
            </el-radio-group>
          </el-form-item>
          <div v-if="form.ifSend === 'send'">
            <el-form-item label-width="0" prop="emailNow">
              <el-radio-group v-model="form.emailNow" size="mini">
                <el-radio label="isEN">Email now</el-radio>
                <el-radio label="isEL">Email later</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item prop="clientContact" label="Client Contact">
              <el-input v-model="form.clientContact"></el-input>
            </el-form-item>
            <el-form-item prop="clientEmail" label="Client Email">
              <el-input type="email" v-model="form.clientEmail"></el-input>
            </el-form-item>
          </div>
          <!--      <el-form-item label="Email Official Receipt (OR)" prop="isEOR">-->
          <!--        <el-checkbox v-model="form.isEOR"></el-checkbox>-->
          <!--      </el-form-item>-->
          <!--      <el-form-item v-if="form.isEOR" label-width="0">-->
          <!--        <el-radio-group v-model="form.timeEmail">-->
          <!--          <el-radio label="isEN">Email Now</el-radio>-->
          <!--          <el-radio label="isEL">Email Later</el-radio>-->
          <!--        </el-radio-group>-->
          <!--      </el-form-item>-->
          <!--      <el-form-item prop="clientContact" label="Client Contact">-->
          <!--        <el-input v-model="form.clientContact">-->
          <!--        </el-input>-->
          <!--      </el-form-item>-->
          <!--      <el-form-item prop="clientEmail" label="Client Email">-->
          <!--        <el-input type="email" v-model="form.clientEmail">-->
          <!--        </el-input>-->
          <!--      </el-form-item>-->
          <!--      <el-form-item prop="ifSend">-->
          <!--        <el-radio-group v-model="form.ifSend" size="mini">-->
          <!--          <el-radio label="dontSend">Don't send email to client</el-radio>-->
          <!--          <el-radio label="send">Send email to client</el-radio>-->
          <!--        </el-radio-group>-->
          <!--      </el-form-item>-->
      </el-col>
      <el-col :span="8">
        <h4>Payment For</h4>
          <el-input class="t-textarea" readonly rows="4" cols="50" type="textarea" :value="paymentFor"></el-input>
      </el-col>
    </el-row>
    <div class="actions__wrapper">
      <el-button type="primary" size="mini" @click="generate">Generate PDF</el-button>
      <el-button type="primary" size="mini" @click="record">Record</el-button>
    </div>
    </el-form>
  </sweet-modal>
</template>

<script>
import { SweetModal } from '@totalflow4/tfsweet-modal-vue'
import axios from "axios";

export default {
  name: "IssueOfficialReceiptModal",
  components: {
    SweetModal
  },
  props: {
    cashReceiptHeaderId: {
      type: [Number, String],
      default: null
    },
    transactionNo: {
      type: String,
      default: null,
    },
    transactionId: {
      type: Number,
      default: null
    },
    paymentFor: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      form: {
        templateName: null,
        orNumber: null,
        issueDate: null,
        // isEOR: false,
        // timeEmail: 'isEN',
        ifSend: 'send',
        emailNow: 'emailNow',
        clientContact: null,
        clientEmail: null,
      },
      rules: {
        // templateName: [
        //   { required: true, message: 'Field is required', trigger: 'change' }
        // ],
        orNumber: [
          { required: true, message: 'Field is required', trigger: 'change' }
        ],
        issueDate: [
          { required: true, message: 'Field is required', trigger: 'change' }
        ],
        clientEmail: [
          { required: true, message: 'Field is required', trigger: 'change' }
        ],
      }
    }
  },
  methods: {
    generate() {

    },
    record() {
      this.$refs['form'].validate(async (valid) => {
        try {
          if (valid) {
            let loader = this.$loading.show();
            const payload = {
              templateName: this.form.templateName,
              orNumber: this.form.orNumber,
              issueDate: this.form.issueDate,
              isEOR: this.form.ifSend === 'send',
              isEN: this.form.emailNow === 'isEN' && this.form.ifSend === 'send',
              isEL: this.form.emailNow === 'isEL' && this.form.ifSend === 'send',
              clientContact: this.form.clientContact,
              clientEmail: this.form.clientEmail
            }
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
            axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
            await axios.post(`/api/v1/cashReceipt/record?cashReceiptHeaderId=${this.cashReceiptHeaderId}&transactionId=${this.transactionId}&companyId=${this.$route.query.companyId}&transactionNo=${this.transactionNo}`, payload)
            loader.hide()
            this.$emit('loadList')
            this.$refs['form'].resetFields()
            this.$refs.modal.close()
          }
        } catch (err) {
          console.log('err', err)
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.actions__wrapper {
  margin-top: 30px;
  display: flex;
  justify-content: space-between;
}
</style>